import { useState } from "react";
import { Alert, Box, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import type { PaidPlanId, PlanId } from "@ebook/contracts";
import { PlanGrid } from "../components/PlanGrid";
import { PaymentSlipDialog } from "../components/PaymentSlipDialog";
import { api } from "../lib/api-client";
import { useAuthStore } from "../stores/auth-store";
import { useTranslate } from "../i18n";

export function ChoosePlanPage() {
  const [selecting, setSelecting] = useState<PlanId | null>(null);
  const [error, setError] = useState("");
  const [paymentPlan, setPaymentPlan] = useState<PaidPlanId | null>(null);
  const setUser = useAuthStore((state) => state.setUser);
  const navigate = useNavigate();
  const __ = useTranslate();

  async function selectPlan(id: PlanId) {
    if (id !== "free") { setPaymentPlan(id); return; }
    setSelecting(id);
    setError("");
    try {
      const updated = await api.updatePlan(id);
      setUser(updated);
      await navigate({ to: "/" });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : __("เลือกแผนไม่สำเร็จ"));
      setSelecting(null);
    }
  }

  return <Box sx={{ maxWidth: 1200, mx: "auto", p: { xs: 3, sm: 5 } }}>
    <Typography variant="h4" fontWeight={800} textAlign="center">{__("เลือกแผนเพื่อเริ่มต้นใช้งาน")}</Typography>
    <Typography color="text.secondary" textAlign="center" mt={1.5} mb={5}>
      {__("คุณสามารถเปลี่ยนแผนได้ภายหลังจากเมนูด้านบนของแอป")}
    </Typography>
    {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
    <PlanGrid mode="picker" currentPlanId={null} onSelect={(id) => void selectPlan(id)} selecting={selecting} />
    {paymentPlan && <PaymentSlipDialog open initialPlan={paymentPlan} onClose={() => setPaymentPlan(null)} onActivated={() => {
      void api.me().then((updated) => { setUser(updated); return navigate({ to: "/" }); });
      setPaymentPlan(null);
    }} />}
  </Box>;
}
